import React from 'react';

function QuoteOpen({ color = 'text-shuttle-grey', size = 'w-8 h-8' }) {
	return (
		<svg className={`fill-current ${color} ${size}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 24">
			<path
				d="M21.7495787,23.0279404 C22.4339538,20.1217383 23.5616003,16.4730721 25.1325522,12.0818326 C26.703504,7.69059311 28.3133167,3.69063311 29.9620384,0.0818326271 L40.1809513,0.0818326271 C38.1278261,8.60882137 36.5568978,16.6087414 35.4681193,24.0818326 L22.4028426,24.0818326 L21.7495787,23.0279404 Z M-0.211205576,23.0279404 C0.473169485,20.1217383 1.60081602,16.4730721 3.17176787,12.0818326 C4.74271971,7.69059311 6.35253235,3.69063311 8.00125409,0.0818326271 L18.220167,0.0818326271 C16.1670418,8.60882137 14.5961135,16.6087414 13.507335,24.0818326 L0.442058261,24.0818326 L-0.211205576,23.0279404 Z"
				transform="translate(1)"
				id="quoteOpen"
			/>
		</svg>
	);
}

export default QuoteOpen;
